import { LatLngTuple } from "@tuliu/leaflet";
import { defineStore } from "pinia";
import { getLngLatToAddress } from "@/api/land";

export type Store = {
  pageTitle: string;
  token: string;
  userLocation: LatLngTuple;
  userLocationCity?: string;
};

export const useMainStore = defineStore("main", {
  state: () => {
    return {
      pageTitle: "",
      token: "",
      userLocation: [39.909187, 116.397451],
      userLocationCity: "北京市",
    };
  },
  actions: {
    async getUserLocationName(loc: LatLngTuple) {
      if (loc != undefined && loc[1] && loc[0]) {
        const params = {
          lng: loc[1],
          lat: loc[0],
        };
        const [err, res] = await getLngLatToAddress(params);
        if (!err && res != undefined) {
          if (res.locInfo.city.name) {
            this.userLocationCity = res.locInfo.city.name;
          }
        }
      }
    },
  },
});
